/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseCheckPublicServiceConsentResponse } from '../models/ApiResponseCheckPublicServiceConsentResponse';
import type { ApiResponseGetPublicServiceTermsResponse } from '../models/ApiResponseGetPublicServiceTermsResponse';
import type { CreatePublicServiceConsentRequest } from '../models/CreatePublicServiceConsentRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class PublicServiceService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * 공공서비스 별 약관동의여부 조회
   * 전달받은 공공서비스의 필수 약관동의여부를 전달합니다.(공공서비스 가입여부전달)
   * @returns ApiResponseCheckPublicServiceConsentResponse OK
   * @throws ApiError
   */
  public checkPublicServiceConsents({
    puid,
    categoryList,
  }: {
    puid: string,
    categoryList: Array<'VEHICLE_INSPECTION' | 'HIGHWAY_UNPAID' | 'LICENSE_RENEWAL' | 'DEMERIT_EDUCATION'>,
  }): CancelablePromise<ApiResponseCheckPublicServiceConsentResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/public-service/terms-consent',
      query: {
        'puid': puid,
        'categoryList': categoryList,
      },
    });
  }
  /**
   * 공공서비스 약관동의
   * 전달받은 공공서비스의 약관을 동의합니다.
   * @returns any OK
   * @throws ApiError
   */
  public consentTerms({
    requestBody,
  }: {
    requestBody: CreatePublicServiceConsentRequest,
  }): CancelablePromise<Record<string, any>> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/public-service/terms-consent',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * 공공서비스 약관 철회
   * 공공서비스의 약관을 철회합니다.
   * @returns any OK
   * @throws ApiError
   */
  public deleteTermsConsent({
    puid,
    categoryList,
  }: {
    puid: string,
    categoryList: Array<'VEHICLE_INSPECTION' | 'HIGHWAY_UNPAID' | 'LICENSE_RENEWAL' | 'DEMERIT_EDUCATION'>,
  }): CancelablePromise<Record<string, any>> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/public-service/terms-consent',
      query: {
        'puid': puid,
        'categoryList': categoryList,
      },
    });
  }
  /**
   * @returns any OK
   * @throws ApiError
   */
  public proxy({
    serviceName,
    method,
    path,
    requestBody,
  }: {
    serviceName: string,
    method: string,
    path: string,
    requestBody: Record<string, Record<string, any>>,
  }): CancelablePromise<Record<string, Record<string, any>>> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/public-service/proxy',
      query: {
        'serviceName': serviceName,
        'method': method,
        'path': path,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * 공공서비스 약관정보 조회
   * 공공서비스의 약관 상세 정보를 제공합니다.
   * @returns ApiResponseGetPublicServiceTermsResponse OK
   * @throws ApiError
   */
  public getPublicServiceTerms({
    puid,
    termsCategory,
  }: {
    puid: string,
    termsCategory: 'VEHICLE_INSPECTION' | 'HIGHWAY_UNPAID' | 'LICENSE_RENEWAL' | 'DEMERIT_EDUCATION',
  }): CancelablePromise<ApiResponseGetPublicServiceTermsResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/public-service/terms',
      query: {
        'puid': puid,
        'termsCategory': termsCategory,
      },
    });
  }
  /**
   * @returns any OK
   * @throws ApiError
   */
  public getKeyCache(): CancelablePromise<Record<string, any>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/public-service/key-cache',
    });
  }
  /**
   * @returns any OK
   * @throws ApiError
   */
  public getCache({
    cacheKey,
  }: {
    cacheKey: string,
  }): CancelablePromise<Record<string, any>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/public-service/cache',
      query: {
        'cacheKey': cacheKey,
      },
    });
  }
}
